import React from "react";
import { Box, LinearProgress } from "@mui/material";
import { getProgressBarColors } from "../utils/progressCalculations";

interface ProgressWrapperProps {
  value: number;
  status?: string;
}

export const ProgressWrapper: React.FC<ProgressWrapperProps> = ({
  value,
  status,
}) => {
  const progressColors = getProgressBarColors(status || "");

  return (
    <Box
      sx={{
        width: 144,
        position: "relative",
        flex: "0 0 144px",
      }}
    >
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height: 20,
          borderRadius: 1,
          backgroundColor: progressColors.background,
          "&.MuiLinearProgress-root": {
            borderRadius: "4px",
          },
          "& .MuiLinearProgress-bar": {
            backgroundColor: progressColors.bar,
            borderRadius: 1,
          },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          color: "var(--ui-text-inverse-default)",
          fontSize: "12px",
          fontWeight: 500,
          lineHeight: "16px",
          zIndex: 1,
        }}
      >
        {Math.round(value)}%
      </Box>
    </Box>
  );
};
